// GST status of a reported or transacted value. Stored as the id.
export const GST_STATUSES: { id: number, name: string }[] = [
  { id: 1, name: 'Exclusive of GST' },
  { id: 2, name: 'Inclusive of GST' },
  { id: 3, name: 'Inclusive of GST, if any' },
  { id: 4, name: 'Inclusive of GST (Margin scheme)' },
  { id: 5, name: 'GST Free' },
]
